//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { DownloadOutlined, PlusSquareOutlined, InfoCircleOutlined , EditOutlined , CaretDownOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Modal } from '@mui/material';
import { Snackbar, Alert } from '@mui/material';
//  -- Components ---------------------
import { Col, Drawer, Dropdown, Menu, Row , Tooltip } from 'antd';
import EmptyState from 'components/EmptyState';
import Submission from 'components/Submission';

import Loading from 'components/Loading';
import { TbgIconimg } from "utils/assets/images";
//  -- Features -----------------------
// import AssignmentReview from 'features/forms/AssignmentReview';
import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import AssignmentReview from 'features/forms/AssignmentReview';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import ChangePasswordForm from 'features/forms/ChangePassword';
import StudentForm from 'features/forms/Student';
import GradebookCalendar from 'features/GradebookCalendar';
import GradeTable from 'features/GradeTable';
import { lighten } from 'polished';
import { connect, useDispatch } from 'react-redux';
//  -- Thunks -------------------------
import { handleCreateUserPreference, handleUpdateUserPreference, handleGetUserPreference } from 'store/userPreference/thunks';
import { handleSyncClassGradeToCanvas, handleSyncGrade, handleEnqueueDedupeCanvasAssignments } from "store/canvas/thunks"
import { handleListClassSubmissions, handleListSubmissionsByAssignmentAndClass, handleListUserSubmissionsByClass } from 'store/submissions/thunks';
import { handleListClassUsers } from 'store/userClasses/thunks';
import { handleListActivityOrQuizData, handleListClassActivities, handleReorderGradebookAssignments } from 'store/classActivities/thunks';
import { handleListClassQuizzes } from 'store/classQuizzes/thunks';
import { useCurrentOrgPermission, useParentOrgId } from 'store/organizations/selectors';
import styled from 'styled-components';
import {  filterMainGradebookClassQuizOrActivity, GRADE_PREF  } from 'utils/lib/ebookHelper';
import { useStory } from 'store/story/selectors';
import { getCurrenSem, semeterDateByYear, getSem1EndDate } from 'utils/methods/math';
//  -- Constants ----------------------
import { map, uniqBy, find, get, filter, groupBy, has, concat, cloneDeep } from 'lodash';
import COLOR from 'utils/constants/color';
import { matrixToCsvString, writeSimpleMatrixExcelBuffer } from 'utils/gradebookMatrixExcelExport';
import dayjs from 'utils/dayjsConfig';
import StudentReview from './forms/StudentReview';
import { useApExams } from 'store/apexams/selectors';
import { useUserClasses } from 'store/userClasses/selectors';
import {  MenuBook, RefreshOutlined, SyncDisabled } from '@mui/icons-material'
import { useClassGameActivity } from 'store/one_game/selectors';
import { handleSyncClassworkAssignment, handleSyncClassworkGeades } from 'store/googleClassRoom/thunks';
import { handleCleverClassesUserSync } from 'store/clever/thunks';
import { handlesynClassUsers } from 'store/classlink/thunks';
import { Tune } from '@mui/icons-material';
import GradeDownloader from 'components/GradeDownloader';
import { parseDateRangeValue } from 'utils/methods/gradebookDateRange';
import { filterGradebookStudentsByActiveStatus } from 'utils/methods/gradebookStudentActiveFilter';
import { useSchoologyAssignment, useSchoologyGradeCategory } from 'store/schoologyauth/selectors';
import { storage } from 'firebaseConfig';
import { ref as fireRef, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { handleCreateDownloadList } from 'store/exams/thunks';
import ModalMenu from 'components/Modals';
import { handleGetRubric } from 'store/rubric/thunks';
import SentryWrap from 'components/Sentry';
import { handleSyncGradeToSchoologyFormOwe } from 'store/schoology/thunks';
import ViewDropdown from 'components/gradebook/ViewBy';
import TbgLabels from 'components/gradebook/TbgLabels';
import * as Sentry from "@sentry/react";
import { useCurrentClassBook } from 'store/classes/selectors';
import BringDataFromSectionModal from 'components/gradebook/BringDataFromSectionModal';
import GradebookSkeleton from 'components/gradebook/GradebookSkeleton';
import AssignmentReviewSkeleton from 'components/gradebook/AssignmentReviewSkeleton';
import { handleListLastSemActiveClass } from 'store/assignment/thunks';
import SpinLoader from 'components/Loader/SpinLoader';
import { useUI } from 'store/UI/selectors';

const ORDER_BY = [
    { key: "asc", value: "Ascending" },
    { key: "desc", value: "Descending" },
]


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const ModalContent = styled.div`
    align-items: center;
    background-color: transparent;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 500px;
    padding: 0;
    position: absolute;
    text-align: left;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;

const Button = styled.button`
    background-color: transparent;
    border: none;
    color: ${COLOR.green200};
    cursor: pointer;
    outline: none;
    transition: all 300ms ease;

    &:hover {
        color: ${COLOR.green}
    }
`;

const CenterContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    width: 100%;
`;

const Error = styled.div`
    background-color: ${lighten(0.4, 'red')};
    border: 1px solid red;
    border-radius: 3px;
    color: red;
    font-size: 14px;
    font-weight: 500;
    margin: 0px auto 16px;
    max-width: 480px;
    padding: 8px;
    text-align: center;
    width: 100%;
`;

const Header = styled.div`
    align-items: center;
    border-bottom: 1px dashed ${COLOR.black800};
    color: ${COLOR.black200};
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-weight: 600;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 8px;
`;

const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;

const Wrap = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap:wrap;
`;

const Wrapper = styled.div`
    width: 100%;
`;


const ColorBox = styled.div`
    height:10px;
    width:20px;
    margin-right: 5px;
`;
const ClassSelector = styled.div`
    min-height: 20px;
    min-width:100px;
    border-radius: 20px;
    background: #2d8a88;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    color: #fff;
    display: flex;
    align-items: center;
    cursor: pointer;
    text-transform: capitalize;
    overlow:hidden;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 3px 7px;
    font-size: 12px;
    margin: 5px 0px 5px 5px;
`;

const StudentStatusSelector = styled.div`
    min-height: 20px;
    border-radius: 20px;
    background: #4a90e2;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    color: #fff;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 5px 10px;
    font-size: 12px;
    margin: 5px 16px 5px 5px;
    transition: all 0.3s ease;
    
    &:hover {
        background: #357abd;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
`;
const ClassMenu = styled.div`
 &::-webkit-scrollbar {
    width: 12px; /* width of the entire scrollbar */
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; /* color of the tracking area */
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888; 
    border-radius: 10px; 
    border: 3px solid #f1f1f1; 
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }

  &::-webkit-scrollbar-button {
    display: block;
    height: 20px; 
  }

  &::-webkit-scrollbar-button:single-button {
    background-color: #f1f1f1; 
    display: block;
    background-size: 10px; 
    background-repeat: no-repeat;
  }


`;
//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Gradebook
//
//  -- Description
//  District and class announcements
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  <Gradebook />
//
const groupAssignment = (submissions) => {
    const gp = groupBy(submissions, 'assignmentId');
    const res = {}
    Object.keys(gp).forEach(key => {
        res[key] = uniqBy(gp[key], "userId")
    })
    return res;
}

const Gradebook = ({
    classActivities,
    classQuizzes,
    currentClass,
    currentOrg,
    classUsers,
    submissions,
    currentUser,
    booksAllList,
    handleEditQuiz,
    handleEditActivity,
    userPreference,
    activities,
    quizzes,
    onswithClass,
    itemloading=false
}) => {
    const { mainGradeTableActive } = useUI();
    const showAlert = useAlert();
    const story = useStory()
    const apExam = useApExams()
    const userClasses = useUserClasses()
    const { class_game_activity, fetchClassGameActivity } = useClassGameActivity()
    const parentOrgId = useParentOrgId();
    const classQuizzesData = useMemo(() => filterMainGradebookClassQuizOrActivity(classQuizzes,story,get(apExam[0],"exams")), [classQuizzes,story,apExam])
    const classActivityData = useMemo(() => [...class_game_activity,...filterMainGradebookClassQuizOrActivity(classActivities,story,get(apExam[0],"exams"))], [classActivities,story,apExam,class_game_activity])
    const currentDistSemester = useMemo(() => getCurrenSem(parentOrgId), [parentOrgId])
    const [currentDisplayedSem, setCurrentDisplayedSem] = useState(getCurrenSem(parentOrgId));
    const [gradeTableDateRange, setGradeTableDateRange] = useState('');
    const isInitialGradebookMount = useRef(true);

    useEffect(() => {
        if (isInitialGradebookMount.current) {
            isInitialGradebookMount.current = false;
            return;
        }
        setGradeTableDateRange('');
    }, [currentDisplayedSem, parentOrgId]);

    const activeDateFilterDisplay = useMemo(() => {
        if (!gradeTableDateRange || gradeTableDateRange === 'all') return null;
        const parsed = parseDateRangeValue(gradeTableDateRange);
        if (!parsed) return null;
        return {
            start: dayjs(parsed.start).format('MMM D, YYYY'),
            end: dayjs(parsed.end).format('MMM D, YYYY')
        };
    }, [gradeTableDateRange]);
    const hiddenAssignmentsCount = useMemo(() => {
        if (!currentDisplayedSem) {
            const allAssignments = [...(classQuizzesData || []), ...(classActivityData || [])];
            return allAssignments.filter(assignment => get(assignment, 'is_hidden', false)).length;
        }
        
        const targetSem = currentDisplayedSem.trim();
        const semMatch = targetSem.match(/semester (\d+) - (\d+)/);
        if (!semMatch) {
            const allAssignments = [...(classQuizzesData || []), ...(classActivityData || [])];
            return allAssignments.filter(assignment => get(assignment, 'is_hidden', false)).length;
        }
        
        const targetSemNumber = parseInt(semMatch[1], 10);
        const targetYear = parseInt(semMatch[2], 10);
        const isSpecial = parentOrgId && ['e5dcb06f-f78d-457a-bacf-8fa357b38ee2', '37ae9554-0da4-4d62-b04f-ec500b0275a4'].includes(parentOrgId);
        
        const { sem1StartDate, sem1EndDate, sem2StartDate, sem2EndDate } = semeterDateByYear(targetYear, parentOrgId);
        const semesterStartDate = targetSemNumber === 1 ? sem1StartDate : sem2StartDate;
        const semesterEndDate = targetSemNumber === 1 ? sem1EndDate : sem2EndDate;
        
        let count = 0;
        const allAssignments = [...(classQuizzesData || []), ...(classActivityData || [])];
        
        for (const assignment of allAssignments) {
            if (!get(assignment, 'is_hidden', false)) continue;
            
            const dueDate = get(assignment, 'dueDate');
            if (!dueDate) continue;
            
            const assignmentMoment = dayjs(dueDate);
            if (!assignmentMoment.isValid()) continue;
            
            if (isSpecial && targetSemNumber === 1) {
                const assignmentYear = assignmentMoment.year();
                const assignmentMonth = assignmentMoment.month();
                const assignmentDay = assignmentMoment.date();
                const sem1EndDay = getSem1EndDate(parentOrgId);
                
                if (assignmentMonth === 0 && assignmentDay <= sem1EndDay) {
                    if (assignmentYear - 1 !== targetYear) continue;
                } else if (assignmentMonth >= 6) {
                    if (assignmentYear !== targetYear) continue;
                } else {
                    if (assignmentYear - 1 !== targetYear) continue;
                }
            } else if (isSpecial && targetSemNumber === 2) {
                const assignmentYear = assignmentMoment.year();
                if (assignmentYear !== targetYear) continue;
            } else {
                const assignmentYear = parseInt(assignmentMoment.format("YYYY"), 10);
                if (assignmentYear !== targetYear) continue;
            }
            
            if (assignmentMoment.isBetween(semesterStartDate, semesterEndDate, 'day', '[]')) {
                count++;
            }
        }
        
        return count;
    }, [classQuizzesData, classActivityData, currentDisplayedSem, parentOrgId])
    const assignment_submission = useMemo(() => {
        return submissions.map(k => {
            if (k.assignmentType === 'game' || k.assignmentType === 'debate' || k.assignmentType === 'bingo' || k.assignmentType === 'worksheet') {
                const game = find(class_game_activity, ['session_id', k.assignmentId])
                if (game) {
                    return ({
                        ...k,
                        assignment: game.assignment,
                    })
                } else {
                    return k;
                }
            }
            const graphic_organizer = find(classActivityData, ["activityId", k.assignmentId])
            if (graphic_organizer && graphic_organizer.data?.activity_type === "graphic_organizer") {
                return ({
                    ...k,
                    assignment: graphic_organizer.data,
                })
            }
            return k;
        })
    }, [submissions, class_game_activity,classActivityData]); 
    const isSchoologyUser = !!(currentUser && currentUser.schoologyid)
    const isCleverUser = !!(currentUser && currentUser.cleverId);
    const isCanvasUser = !!(currentUser && currentUser.canvas_id);
    const isGoogleUser = !!(currentUser && currentUser.googleId);
    const isClassLinkuser = !!(currentUser && currentUser.classlinkid);
    const isUserFromOtherPlatform =  isSchoologyUser || isCleverUser || isGoogleUser || isClassLinkuser || isCanvasUser
    const howGradeScale =    !isGoogleUser &&  !isCanvasUser && !isSchoologyUser
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState({});
    const isReviewAccount = currentUser?.reviewAccount || false
    const [editing, setEditing] = useState({});
    const [userDrawer, toggleUserDrawer] = useState(false);
    const [changePasswordDrawer, toggleChangePasswordDrawer] = useState(false);
    const [selectedAssignment, setSelectedAssignment] = useState(null);
    const [maxExceedError, setMaxExccedError] = useState(false);
    const [gradeView, setGradeViw] = useState("gradetable")
    const [examData, setExamData] = useState([])
    const [gradeData, setGradeData] = useState([])
    const [LegendsShow, setLegendsShow] = useState(false);
    const scale_1_5 = useMemo(() => userPreference?.gradePref == "scale_1_5", [userPreference])
    const gradebook_a_f = useMemo(() => userPreference?.gradePref == "gradebook_a_f", [userPreference])
    const [updatePrefLoader, setUpdatePrefLoader] = useState(false);
    const [updateorderByLoader, setUpdateOrderByLoader] = useState(false);
    const [updateDateLoader, setUpdateDateLoader] = useState(false);
    const [orderBy, setOrderBy] = useState("desc");
    const [datePrefrences, setDatePrefrences] = useState('due_date');
    const [editPrevSemData,setEditPrevSemData] = useState(false)
    const [isCurrentSem,setCurrentSem]=useState(true)
    const [syncLoader, setSyncLoader] = useState(false);
    const [dedupeLoader, setDedupeLoader] = useState(false);
    const [selectedUserData, setSelectedUserData] = useState({})
    const [schoologyGradeCategory,,,listAllclassSchoologyGradeCategory] = useSchoologyGradeCategory()
    const [, listSchoologyAssignment] = useSchoologyAssignment();
    const gradeDownloadRef = useRef()
    const [sortBy,setSortBy] = useState('last_a_z')
    const [openPop, setOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [openListRubricModal, setOpenListRubricModal] = useState(false);
    const [rubricLoading, setRubricLoading] = useState(false);
    const [highlightConfig,setHighlightConfig] = useState({});
    const allowed_books = useCurrentClassBook();
    const [activeInactive, setActiveInactive] = useState('active');
    const [bringDataModal, setBringDataModal] = useState(false);
    const [bringDataLoading, setBringDataLoading] = useState(false);
    const [spinLoader, setSpinLoader] = useState(false);

    const onRubricClick = async () => {
        setRubricLoading(true);
        await dispatch(handleGetRubric(currentUser?.id));
        setRubricLoading(false);
        setOpenListRubricModal(true);
    }

    const handeListSubmissionAPI = async () => {
        if (!currentClass?.id) return;
        setSpinLoader(true);
        try {
            await dispatch(handleListClassSubmissions(currentClass.id));
        } finally {
            setSpinLoader(false);
        }
    };



    const onClickMenu = (e) => {
        if (e.key === 'Ascending') {
            setOrderBy('asc')
            handleUpdateorderByPref('asc')
            setOpenKeys([])
        }
        if (e.key === 'Descending') {
            setOrderBy('desc')
            handleUpdateorderByPref('desc')
            setOpenKeys([])
        }
        if (e.key === 'Average_Grade') {
            handleUpdateGradePref('average')
            setOpenKeys([])
        }
        if (e.key === 'Sync_to_Schoology') {
            syncToSchoology();
        }
        if (e.key === 'Sync_canvas') {
            syncToCanvas();
        }
        if (e.key === 'Sync_canvas_dedupe') {
            syncDuplicatesCanvas();
        }
        if (e.key === 'Sync_google_classroom') {
            handleGoogleClassRomm();
        }
        if (e.key === 'Grade_in') {
            handleUpdateGradePref('scale_1_5')
            setOpenKeys([])
        }
        if (e.key === 'Gradebook_with') {
            handleUpdateGradePref('gradebook_a_f')
            setOpenKeys([])
        }
        if (e.key === 'Legends') {
            handleLegendsShow();
        }
        if (e.key === 'Rubric') {
            onRubricClick();
        }
        if (e.key === 'Refresh') {
            handeListSubmissionAPI();
        }
        if (e.key === 'XLSX') {
            if (gradeView == "gradetable") {
                generateCSV(gradeData, 'xlsx');
            } else {
                generateCSV(examData, 'xlsx');
            }
        }
        if (e.key === 'CSV') {
            if (gradeView == "gradetable") {
                generateCSV(gradeData, 'csv');
            } else {
                generateCSV(examData, 'csv');
            }
        }
        if(e.key === "download"){
            gradeDownloadRef.current.open()
        }
        if (e.key === 'Add_Student') {
            setEditing(false);
            setUserData({
                username: '',
                password: ''
            });
            toggleUserDrawer(true);
        }
    };

    useEffect(() => {
        if (userPreference && typeof userPreference.orderBy === "string") {
            if (userPreference.orderBy === "asc" || userPreference.orderBy === 'desc') {
                setOrderBy(userPreference.orderBy)
            }
        }
        if (userPreference && typeof userPreference.order_by_date === "string") {
            if (["start_date", "due_date", "late_submission"].includes(userPreference.order_by_date)) {
                setDatePrefrences(userPreference.order_by_date)
            }
        } else if (!userPreference || !userPreference?.order_by_date) {
            setDatePrefrences('due_date')
        }
    }, [userPreference])
    useEffect(()=>{
        setEditPrevSemData(Boolean(localStorage.getItem("editPrevSemData")))
    },[])
    const handleLegendsShow = () => {
        setLegendsShow(true);
    }
 
    const fetchAllData = async () => {
        setLoading(false);
        const currentClassIdForGrade = localStorage.getItem("currentClassIdForGrade")
        if ((currentClassIdForGrade && currentClassIdForGrade === currentClass?.id) || (!currentClass?.id && currentClassIdForGrade === "noclasssid")) {
            setLoading(false);
            await Promise.allSettled([
                dispatch(handleListClassSubmissions(get(currentClass, "id")))
                 // dispatch(handleListClassSubmissionsBySem(currentClass.id, currentSemDateRange.from_date, currentSemDateRange.end_date)),
            ])
        }
        localStorage.setItem("currentClassIdForGrade", currentClass?.id ?? "noclasssid")
        setLoading(false);
        // listAllBooks(),
        // dispatch(handleListClassUsers(get(currentClass, "id"))),
        // dispatch(handleListUserBooks(currentUserId)),
        await Promise.allSettled([
            handleGoogleClassRomm(),
            syncGradeForCanvas(),
            listAllclassSchoologyGradeCategory(),
            listSchoologyAssignment(currentClass.sectionId)
        ])
    }
    const handleGoogleClassRomm = async () => {
        try {
            setSyncLoader(true);
            if (has(currentUser, "googleId") && currentUser.googleId) {
                await handleSyncClassworkAssignment(currentUser.googleId, currentClass.id);
                await handleSyncClassworkGeades(currentUser.googleId, currentClass.id, currentClass.googleId);
                await dispatch(handleListClassSubmissions(get(currentClass, "id")))
            }
            setSyncLoader(false);
        } catch (error) {
            Sentry.captureException(`523 Error in handleGoogleClassRomm: ${error}`);
            setSyncLoader(false);
        }
    }
    useEffect(() => {
        fetchAllData();
    }, [currentClass])


    const syncGradeForCanvas = async () => {
        try {
            if (currentClass?.canvas_id) {
                setSyncLoader(true)
                await Promise.allSettled([
                    handleSyncGrade(currentUser.canvas_id, currentClass.canvas_course_id, currentClass.canvas_id, currentUser.canvas_auth_id),
                    handleSyncClassGradeToCanvas(currentClass.id, currentUser.id)
                ])
                // await   dispatch(handleListClassSubmissions(get(currentClass, "id")))
                setSyncLoader(false)
            }
        } catch (error) {
            Sentry.captureException(`524 Error in syncGradeForCanvas: ${error}`);
            console.log(error, "bid-err");
              setSyncLoader(false)
        }

    }

    const [assignmentData, setAssignmentData] = useState({});
    const [selectedAssignmentUserSubmission, setSelectedAssignmentSubmissions] = useState([])
    const [assignmentDrawer, toggleAssignmentDrawer] = useState(false);
    const [assignmentReviewLoading, setAssignmentReviewLoading] = useState(false);
    const [pendingReviewData, setPendingReviewData] = useState(null);
    const [returnedSubmissionIds, setReturnedSubmissionIds] = useState(() => ({}));
    const onReturnSuccess = useCallback((id, submissionNo) => {
        if (!id) return;
        setReturnedSubmissionIds(prev => ({ ...prev, [id]: submissionNo }));
    }, []);
    const [studentAssignmentDrawer, setStudentAssignmentDrawer] = useState(false);
    const [formatPasswordError, setFormatPasswordError] = useState(false);
    //  -- User ---------------------------



    const updateUserData = (id, value) => {
        setUserData({
            ...userData,
            [id]: value
        });
        setFormatPasswordError(false);
    };

    const studentSubmissions = useMemo(() => groupAssignment(assignment_submission) || {}, [assignment_submission])
    const activeStudentUsers = useMemo(() => {
        const sortname = (a, b) => {
            const nameA = a?.lastName?.toLowerCase()?.replace(/\s/g, '');
            const nameB = b?.lastName?.toLowerCase()?.replace(/\s/g, '');
            if (nameA < nameB) { return -1 }
            else if (nameA > nameB) { return 1 }
            else { return 0 }
        }
        return filter(classUsers, x => x.role === 'student' && x.active).sort(sortname)
    }, [classUsers]);
    const reviewAssignment = useCallback(async (data) => {
        try {
            setAssignmentReviewLoading(true);
            toggleAssignmentDrawer(true);
            setPendingReviewData(null);
            setAssignmentData(data || {});
            setSelectedAssignmentSubmissions([]);
            const tempData = getAssignmentCreation({ data: get(data, "assignment") }, get(data, "user"));
            const users = activeStudentUsers;
            const assignmentId = data?.assignmentId;
            const classId = get(currentClass, "id");
            const submissionsResult = await   dispatch(handleListSubmissionsByAssignmentAndClass(assignmentId, classId,true))
            const apiSubmissions = Array.isArray(submissionsResult) ? submissionsResult : [];
            const apiUserSubmissions = groupBy(apiSubmissions, "userId");
            setPendingReviewData({
                data,
                tempData,
                users,
                userSubmissions: apiUserSubmissions
            });
        } catch (error) {
            Sentry.captureException(`526 Error in reviewAssignment: ${error}`);
            toggleAssignmentDrawer(false);
            setPendingReviewData(null);
            setAssignmentData({});
            setSelectedAssignmentSubmissions([]);
        } finally {
            setAssignmentReviewLoading(false);
        }
    }, [activeStudentUsers, currentClass, dispatch, getAssignmentCreation]);
    const closeAssignmentDrawer = useCallback(() => {
        toggleAssignmentDrawer(false);
        setPendingReviewData(null);
        setAssignmentData({});
        setSelectedAssignmentSubmissions([]);
    }, []);
    const handleAssignmentReviewClose = useCallback(() => {
        setLoading(true);
        toggleAssignmentDrawer(false);
        setPendingReviewData(null);
        setLoading(false);
        fetchAllData();
    }, [fetchAllData]);
    const isAssignmentReviewReady = useMemo(() => {
        if (!assignmentDrawer) return false;
        if (!assignmentData || !assignmentData.assignmentId) return false;
        return Array.isArray(selectedAssignmentUserSubmission) && selectedAssignmentUserSubmission.length > 0;
    }, [assignmentDrawer, assignmentData, selectedAssignmentUserSubmission]);

    const processPendingReviewData = useCallback((pendingData) => {
        if (!pendingData) return null;
        const { data, tempData, users, userSubmissions } = pendingData;
        const matchedAssignment = concat(classActivityData, classQuizzesData, class_game_activity).filter(
            a => (a.quizId === data?.assignmentId || a.activityId === data?.assignmentId || a.session_id == data?.assignmentId)
        )[0];
        let sAssignmentId = get(data, "sAssignmentId");
        if (matchedAssignment?.sAssignmentId) {
            sAssignmentId = matchedAssignment.sAssignmentId;
        }

        let processedData = data;
        if (processedData) {
            processedData.sAssignmentId = sAssignmentId;
        }
        if (!processedData) {
            const utemp = cloneDeep(tempData);
            utemp.isTemp = true;
            utemp.sAssignmentId = sAssignmentId;
            processedData = utemp;
        }

        const assignmentId = get(processedData, "assignmentId", get(tempData, "assignmentId"));
        const submissionSource = userSubmissions || {};
        const buildTempSubmission = (usr) => {
            const baseUser = usr?.active
                ? { ...usr, active: usr?.userclass?.active }
                : usr;
            return {
                ...tempData,
                userId: usr.id,
                user: baseUser,
                isTemp: true,
                sAssignmentId
            };
        };

        const processedUsers = map(users, usr => {
            const sub = submissionSource[usr.id];
            if (Array.isArray(sub) && sub.length > 0) {
                const subByAssignmentId = new Map(sub.map(n => [get(n, "assignmentId"), n]));
                const asub = subByAssignmentId.get(assignmentId);
                if (asub) {
                    const processedSub = { ...asub, sAssignmentId };
                    if (processedSub.user && processedSub.user.active) {
                        processedSub.user = { ...processedSub.user, active: usr.userclass.active };
                    }
                    return processedSub;
                }
            }
            return buildTempSubmission(usr);
        });

        return { processedData, processedUsers };
    }, [classActivityData, classQuizzesData, class_game_activity]);

    useEffect(() => {
        if (!assignmentDrawer || !pendingReviewData) return;
        requestAnimationFrame(() => {
            const processedResult = processPendingReviewData(pendingReviewData);
            if (!processedResult) return;
            setSelectedAssignmentSubmissions(processedResult.processedUsers);
            setAssignmentData(processedResult.processedData);
        });
    }, [assignmentDrawer, pendingReviewData, processPendingReviewData]);

    const userReviewAssignment = useCallback(async (user, assignment) => {
        try {
            setAssignmentReviewLoading(true);
            setStudentAssignmentDrawer(true);
            setSelectedUserData({});
            const usersub = await dispatch(handleListUserSubmissionsByClass(user?.id, currentClass?.id,true));
            const userSubmissions = Array.isArray(usersub) ? usersub : [];
            const reviewData = {
                user,
                assignments: map(assignment, asign => {
                    const tempData = getAssignmentCreation(asign, user);
                    const is_game = asign.type === 'game';
                    const is_debate = asign.type === 'debate';
                    const is_worksheet = asign.type === 'worksheet';
                    const is_loteria = asign.type === 'bingo';
                    const assignment_id = is_game || is_loteria || is_debate || is_worksheet ? asign.session_id : asign.data?.id;
                    const u_submissions = find(userSubmissions, ['assignmentId', assignment_id]);
                    const assignmentData = ((is_game || is_loteria || is_debate || is_worksheet) && !asign.data && asign.assignment)
                        ? {
                            ...asign,
                            data: {
                                ...asign.assignment,
                                bookId: asign.assignment.chapter,
                                typeId: asign.type || "game",
                            }
                        }
                        : asign;
                    const enrichedSubmission = u_submissions?.assignment && !u_submissions?.assignment?.questions?.length && (assignmentData.data?.questions || assignmentData.assignment?.questions)
                        ? {
                            ...u_submissions,
                            assignment: {
                                ...u_submissions.assignment,
                                questions: assignmentData.data?.questions || assignmentData.assignment?.questions
                            }
                        }
                        : u_submissions;
                    return {
                        ...assignmentData,
                        submissions: enrichedSubmission && Object.keys(enrichedSubmission || {}).length > 0 ? enrichedSubmission : tempData
                    };
                }),
                class_users: activeStudentUsers,
                assignment
            };
            setSelectedUserData(reviewData);
            setStudentAssignmentDrawer(true);
        } catch (error) {
            Sentry.captureException(`527 Error in userReviewAssignment: ${error}`);
            setSelectedUserData({});
            setStudentAssignmentDrawer(false);
        } finally {
            setAssignmentReviewLoading(false);
        }
    }, [activeStudentUsers, currentClass?.id, dispatch, getAssignmentCreation]);



    const handleUpdateGradePref = async (_scale) => {
        setUpdatePrefLoader(true)
        if (!userPreference || typeof userPreference == "object" && Object.keys(userPreference).length == 0) {
            await dispatch(handleCreateUserPreference(currentUser?.id, { gradePref: _scale }))
        } else {
            await dispatch(handleUpdateUserPreference(currentUser?.id, { gradePref: _scale }))
        }
        // await getPref()
        setUpdatePrefLoader(false)
    }
    const handleUpdateorderByPref = async (_orderBy) => {
        setUpdateOrderByLoader(true)
        if (currentUser) {
            if (!userPreference || typeof userPreference == "object" && Object.keys(userPreference).length == 0) {
                await dispatch(handleCreateUserPreference(currentUser.id, { orderBy: _orderBy }))
            } else {
                await dispatch(handleUpdateUserPreference(currentUser.id, { orderBy: _orderBy }))
            }
        }
        setUpdateOrderByLoader(false)
    }

    const handleUpdateDatePref = async (order_by_date) => {
        setUpdateDateLoader(true)
        if (currentUser) {
            if (!userPreference || typeof userPreference == "object" && Object.keys(userPreference).length == 0) {
                await dispatch(handleCreateUserPreference(currentUser.id, { order_by_date }))
            } else {
                await dispatch(handleUpdateUserPreference(currentUser.id, { order_by_date }))
            }
            setOpen(true);
            setPopupMessage(`This change will be automatically updated to all the classes`)
        }
        setUpdateDateLoader(false)
    }

    const handlePersistCalendarAssignmentOrder = useCallback(async (dayKey, orderedKeys) => {
        try {
            if (!currentUser?.id || !currentClass?.id) return;
            await dispatch(handleReorderGradebookAssignments(currentClass.id, orderedKeys));
        } catch (error) {
            Sentry.captureException(error);
        }
    }, [currentUser?.id, currentClass?.id, dispatch]);

    function getAssignmentCreation(assignmentdata, userdata) {
        try {
            const is_game = assignmentdata && (assignmentdata.type === 'game' || assignmentdata.type === 'debate' || assignmentdata.type === 'bingo' ||   assignmentdata.type === 'worksheet');
            if(is_game) {
                let quizdata = {
                    answers: [],
                    assignment: assignmentdata.assignment,
                    assignmentId: assignmentdata.session_id,
                    assignmentType: assignmentdata.type,
                    chapter: assignmentdata.bookId,
                    classId: currentClass.id,
                    complete: false,
                    createdAt: Date.now(),
                    feedback: '',
                    grade: null,
                    graded: true,
                    isLate: false,
                    orgId: currentOrg?.id,
                    retakes: 0,
                    retaking: false,
                    submissions: 0,
                    face_grade: null,
                    timmer: 0,
                    user: userdata,
                    userId: userdata.id,
                    bookId: assignmentdata.bookId,
                    isTemp: true
                }
                return quizdata;
            }else{
                let _assignmentinfo = assignmentdata.data ?? {};
                let quizdata = {
                    answers: [],
                    assignment: _assignmentinfo,
                    assignmentId: _assignmentinfo.id,
                    assignmentType: _assignmentinfo.typeId,
                    chapter: _assignmentinfo.chapter,
                    classId: currentClass.id,
                    complete: false,
                    createdAt: Date.now(),
                    feedback: '',
                    grade: '0',
                    graded: true,
                    isLate: false,
                    orgId: currentOrg?.id,
                    retakes: assignmentdata.retakes,
                    retaking: false,
                    submissions: 0,
                    timmer: 0,
                    user: userdata,
                    userId: userdata.id,
                    bookId: _assignmentinfo.bookId,
                    isTemp: true
                }
                return quizdata;
            }
           
        } catch (error) {
            Sentry.captureException(`525 Error in getAssignmentCreation: ${error}`);
            return {};
        }
    }

    const generateCSV = (studentScores, type, f_name , c_id) => {
        void (async () => {
            try {
                const { saveAs } = await import('file-saver');
                const xlsxMime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                const isCsv = String(type).toLowerCase() === 'csv';

                if (gradeView == "gradetable") {
                    if (!studentScores?.length) return;
                    let aoa;
                    if (Array.isArray(studentScores[0])) {
                        aoa = studentScores;
                    } else {
                        const newStudentScores = studentScores.map((student) => {
                            const copy = { ...student };
                            delete copy.scores;
                            return copy;
                        });
                        if (!newStudentScores.length) return;
                        const keys = Object.keys(newStudentScores[0] || {});
                        aoa = [keys, ...newStudentScores.map((obj) => keys.map((k) => obj[k] ?? ''))];
                    }
                    const rawName = f_name || `gradebook ${dayjs().format("DD-MM-YY hh:mm")}.${type}`;
                    const stem = rawName.replace(/\.(csv|xlsx)$/i, '');
                    const file_name = `${stem}.${isCsv ? 'csv' : 'xlsx'}`;
                    if (isCsv) {
                        const csvBody = matrixToCsvString(aoa);
                        const file = new Blob([`\uFEFF${csvBody}`], { type: 'text/csv;charset=utf-8;' });
                        saveAs(file, file_name);
                        await uploadToStorage(file, 'csv', file_name, c_id);
                    } else {
                        const buffer = await writeSimpleMatrixExcelBuffer(aoa);
                        const file = new Blob([buffer], { type: xlsxMime });
                        saveAs(file, file_name);
                        await uploadToStorage(file, 'xlsx', file_name, c_id);
                    }
                } else {
                    if (!studentScores?.firstRow || !studentScores?.data?.length) return;
                    const exambook = [[], [], [], []];
                    Object.keys(studentScores.firstRow).map((keys) => exambook[0].push(keys));
                    Object.values(studentScores.firstRow).map((value) => exambook[1].push(value));
                    Object.keys(studentScores.data[0]).map((keys) => exambook[3].push(keys));
                    map(studentScores.data, (userd) => {
                        const d = [];
                        Object.values(userd).map((value) => d.push(value));
                        exambook.push(d);
                    });
                    const rawName = f_name || `gradebook ${dayjs().format("DD-MM-YY hh:mm:SS")}.${type}`;
                    const stem = rawName.replace(/\.(csv|xlsx)$/i, '');
                    const file_name = `${stem}.${isCsv ? 'csv' : 'xlsx'}`;
                    if (isCsv) {
                        const csvBody = matrixToCsvString(exambook);
                        const file = new Blob([`\uFEFF${csvBody}`], { type: 'text/csv;charset=utf-8;' });
                        saveAs(file, file_name);
                        await uploadToStorage(file, 'csv', file_name, c_id);
                    } else {
                        const buffer = await writeSimpleMatrixExcelBuffer(exambook);
                        const file = new Blob([buffer], { type: xlsxMime });
                        saveAs(file, file_name);
                        await uploadToStorage(file, 'xlsx', file_name, c_id);
                    }
                }
            } catch (err) {
                Sentry.captureException(`529 Error in generateCSV export: ${err}`);
            }
        })();
    }
    const uploadToStorage = async (file, type , file_name,c_id) => {
        if (file) {
          const location = `/grade_book/${type || 'xlsx'}`;
          const id = file_name || `${dayjs().format("MMM DD, YYYY hh:mm A")}-${type}`;
          const fileRef = fireRef(storage, `${location}/${id}`);
          return new Promise((resolve, reject) => {
            try {
              const uploadTask = uploadBytesResumable(fileRef, file);
              uploadTask.on('state_changed',
                (snapshot) => {},
                (error) => {
                  console.error("Upload error:", error);
                  reject(error);
                },
                () => {
                  getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    dispatch(handleCreateDownloadList({
                        title:file_name,
                        url:downloadURL, 
                        class_id:c_id?c_id:currentClass.id, 
                        created_by:currentUser.id
                    }))
                    resolve(downloadURL);
                  });
                }
              );
            } catch (error) {
                Sentry.captureException(`528 Error in uploadToStorage: ${error}`);
              console.error("Upload error", error);
              reject(error);
            }
          });
        } else {
          return null;
        }
      };
    const getAssignment = () => {
        const uniqueActivity = uniqBy(classActivityData, (item) => {
            if (item.type === 'worksheet') {
                return item.session_id || item.id;
            }
            return item.activityId;
        });
        const uniqueQuiz = uniqBy(classQuizzesData, 'quizId');
        const allAssignments = [...uniqueActivity, ...uniqueQuiz];
        
        const filtered = allAssignments.filter(k => {
            const isWorksheet = k.type === 'worksheet';
            const chapter = isWorksheet 
                ? (get(k, "bookId") || get(k, "assignment.chapter") || get(k, "data.bookId") || get(k, "data.chapter"))
                : (get(k, "data.bookId") || get(k, "data.chapter"));
            return chapter?.length > 5 ? true : allowed_books.includes(chapter);
        });
        
        return filtered;
    }

    const onDownloadFile = (type, data, f_name , c_id) => {
        if (type == "XLSX") {
            if (gradeView == "gradetable") {
                generateCSV(data?data:gradeData, 'xlsx',f_name,c_id);
            } else {
                generateCSV(examData, 'xlsx',f_name,c_id);
            }
        } else {
            if (gradeView == "gradetable") {
                generateCSV(data?data:gradeData, 'csv',f_name,c_id);
            } else {
                generateCSV(examData, 'csv',f_name,c_id);
            }
        }
    }

    const downloadNav = (activity, student, submission) => {
        return {
            items: [
                {
                    key: "XLSX",
                    label: (
                        <PaddedBtn onClick={() => {
                            if (gradeView == "gradetable") {
                                generateCSV(gradeData, 'xlsx');
                            } else {
                                generateCSV(examData, 'xlsx');
                            }
                        }}>
                            XLSX
                        </PaddedBtn>
                    ),
                    style: { padding: '0px' }
                },
                {
                    key: "csv",
                    label: (
                        <PaddedBtn onClick={() => {
                            if (gradeView == "gradetable") {
                                generateCSV(gradeData, 'csv');
                            } else {
                                generateCSV(examData, 'csv');
                            }
                        }}>
                            CSV
                        </PaddedBtn>
                    ),
                    style: { padding: '0px' }
                }
            ]
        };
    };
    const gradeNav = () => {
        return {
            items: GRADE_PREF.map((item) => ({
                key: item.key,
                label: (
                    <PaddedBtn onClick={() => {
                        handleUpdateGradePref(item.key)
                    }}>
                        {item.value}
                    </PaddedBtn>
                ),
                style: { padding: '0px' }
            }))
        };
    };
    const orderNav = () => {
        return {
            items: ORDER_BY.map((item) => ({
                key: item.key,
                label: (
                    <PaddedBtn onClick={() => {
                        setOrderBy(item.key)
                        handleUpdateorderByPref(item.key)
                    }}>
                        {item.value}
                    </PaddedBtn>
                ),
                style: { padding: '0px' }
            }))
        };
    };
    const canvasSyncNav = () => ({
        items: [
            {
                key: 'sync_canvas',
                label: (
                    <PaddedBtn onClick={() => syncToCanvas()} disabled={syncLoader || dedupeLoader}>
                        Sync Canvas
                    </PaddedBtn>
                ),
                style: { padding: '0px' },
            },
            {
                key: 'sync_canvas_dedupe',
                label: (
                    <PaddedBtn onClick={() => syncDuplicatesCanvas()} disabled={syncLoader || dedupeLoader}>
                        Fix duplicate Canvas assignments
                    </PaddedBtn>
                ),
                style: { padding: '0px' },
            },
        ],
    });
    const classNav = () => {
        return {
            items: map(userClasses, x => {
                if (x.displayName) {
                    const archived = get(x, "archived", false);
                    if(archived) return null;
                    const isSelected = currentClass.id === x.id;
                    return {
                        key: x.id,
                        label: (
                            <PaddedBtn
                                onClick={() => {
                                    onswithClass(x.id,x.displayName,x)
                                }}>
                                {x.displayName}
                            </PaddedBtn>
                        ),
                        style: { 
                            color: isSelected ? COLOR.white : COLOR.black100,
                            background: isSelected ? COLOR.indigo100 : "transparent",
                            height: 30
                        }
                    };
                }
                return null;
            }).filter(Boolean)
        };
    };
    const syncToSchoology = async () => {
        try {
            setSyncLoader(true);
            await handleSyncGradeToSchoologyFormOwe({
                "classId": currentClass.id,
                "sectionId": currentClass?.sectionId,
                "schoologyid": currentUser.schoologyid
            })
        } catch (error) {
            Sentry.captureException(`529 Error in syncToSchoology: ${error}`);

        } finally {
            setSyncLoader(false);
        }
    }

    const syncToCanvas = async()=>{
        syncGradeForCanvas()
    }

    const syncDuplicatesCanvas = async () => {
        if (!currentClass?.id || !currentUser?.canvas_id || !currentUser?.canvas_auth_id) {
            showAlert('Canvas is not configured for this class.', 'error');
            return;
        }
        try {
            setDedupeLoader(true);
            const result = await handleEnqueueDedupeCanvasAssignments(
                currentUser.canvas_id,
                currentUser.canvas_auth_id,
                currentClass.id,
                'all',
                parentOrgId
            );
            if (result?.error) {
                showAlert(typeof result.error === 'string' ? result.error : 'Failed to queue duplicate cleanup.', 'error');
                return;
            }
            showAlert('Duplicate Canvas cleanup queued for this class and related sections. Grades sync only where duplicates are removed.', 'success');
        } catch (error) {
            Sentry.captureException(`530 Error in syncDuplicatesCanvas: ${error}`);
            showAlert('Failed to queue duplicate Canvas cleanup.', 'error');
        } finally {
            setDedupeLoader(false);
        }
    };

    const [openKeys, setOpenKeys] = useState([]);

    const handleMenuClick = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setOpenKeys((prevKeys) => {
            if (prevKeys.includes('sub1')) {
                return prevKeys.filter(key => key !== 'sub1');
            } else {
                return ['sub1'];
            }
        });
    };

    const getCurrentGradePrefLabel = useCallback(() => {
        if (scale_1_5) return GRADE_PREF[1].value;
        if (gradebook_a_f) return GRADE_PREF[2].value;
        return GRADE_PREF[0].value;
    }, [scale_1_5, gradebook_a_f]);

    const getCurrentGradePrefKey = useCallback(() => {
        if (scale_1_5) return 'Grade_in';
        if (gradebook_a_f) return 'Gradebook_with';
        return 'Average_Grade';
    }, [scale_1_5, gradebook_a_f]);

    const items = [
        {
            key: 'sub1',
            icon: (
                <div 
                    onClick={handleMenuClick}
                    onTouchStart={handleMenuClick}
                    style={{ cursor: 'pointer', touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent' }}
                >
                    <Tune style={{ fontSize: 32, color: '#2d8a88' }} />
                </div>
            ),
            children: [
                {
                    key: 'Order_By_date',
                    label: 'Order By date',
                    children: [
                        { key: 'Ascending', label: 'Ascending' },
                        { key: 'Descending', label: 'Descending' },
                    ],
                },
                {
                    key: 'custom_view_dropdown',
                    label: <div onClick={(e) => e.stopPropagation()}>
                        <ViewDropdown
                        config={highlightConfig}
                        isTabMenu={true}
                        onChange={v=>{
                            setHighlightConfig(v);
                            setOpenKeys([])
                        }}
                        dateRange={gradeTableDateRange}
                        onDateRangeChange={setGradeTableDateRange}
                        activeSem={currentDisplayedSem}
                        parentOrgId={parentOrgId}
                    />
                    </div>,
                 },
                ...(howGradeScale
                    ? [
                        {
                            key: 'Gradebook_with_A-F',
                            label: getCurrentGradePrefLabel(),
                            children: [
                                { key: 'Average_Grade', label: 'Average Grade' },
                                { key: 'Grade_in', label: 'Grade in 0-4' },
                                { key: 'Gradebook_with', label: 'Gradebook with A-F' },
                            ],
                        },
                    ]
                    : []),
                ...(isSchoologyUser
                    ? [{ key: 'Sync_to_Schoology', label: 'Sync to Schoology' }]
                    : []),
                ...(isCanvasUser
                    ? [
                        { key: 'Sync_canvas', label: 'Sync Canvas' },
                        { key: 'Sync_canvas_dedupe', label: 'Fix duplicate Canvas assignments' },
                    ]
                    : []),
                ...(isGoogleUser
                    ? [{ key: 'Sync_google_classroom', label: 'Sync Google Classroom' }]
                    : []),
                { key: 'Refresh', label: 'Refresh' },
                { key: 'Legends', label: 'Legends' },
                { key: 'Rubric', label: 'Rubric' },
                {
                    key: 'download',
                    label: 'Download',
                    icon: <DownloadOutlined />,
                    ...(gradeView !== 'gradetable'
                        ? {
                            children: [
                                { key: 'XLSX', label: 'XLSX' },
                                { key: 'CSV', label: 'CSV' },
                            ],
                        }
                        : {}),
                },
                ...(isUserFromOtherPlatform
                    ? []
                    : [{ key: 'Add_Student', label: 'Add Student' }]),
            ],
        },
    ];

    const handleClose = () => {
        setOpen(false);
    };

    const activeInactiveNav = useCallback(() => {
        return {
            items: [
                { key: 'active', label: 'Active' , onClick: () => {
                    setActiveInactive('active')
                }},
                { key: 'inactive', label: 'Inactive' , onClick: () => {
                    setActiveInactive('inactive')
                }}
            ]
        }
    }, [activeInactive]);

    const isSemester2 = useMemo(() => {
        if (!currentDistSemester) return false;
        return currentDistSemester.includes('semester 2');
    }, [currentDistSemester]);

    const handleBringDataClick = async () => {
        if (!currentClass?.id || !currentUser) return;
        
        setBringDataLoading(true);
        try {
            if (isCleverUser && currentUser.cleverId) {
                await handleCleverClassesUserSync(currentUser.cleverId, currentClass.id);
            } else if (isClassLinkuser && currentUser.classlinkid && currentUser.classlinkTenantId) {
                await handlesynClassUsers(currentUser.classlinkid, currentUser.classlinkTenantId, currentClass.id);
            }
            setBringDataModal(true);
        } catch (error) {
            console.error('Error syncing students:', error);
        } finally {
            setBringDataLoading(false);
        }
    };
    const onSemesterChange = useCallback(async (sem, data) => {
        // TODO: handle date filter reset when the semester is changed
        // const dateFilterActive = gradeTableDateRange && gradeTableDateRange !== 'all' && parseDateRangeValue(gradeTableDateRange);
        // if (dateFilterActive && sem !== currentDisplayedSem) {
        //     showAlert('Date filter resets when the semester is changed.', 'warning');
        // }
        setCurrentDisplayedSem(sem);
        if (sem && sem.includes('semester 1')) {
            const has_data = Array.isArray(data) && data.filter(k => k && Object.keys(k).length > 0).length > 0;
            if (!has_data) {
                try {
                    setSpinLoader(true);
                    const activeStudents = filter(classUsers, x => x.role === 'student' && x.active && x.userclass?.active);
                    if (activeStudents.length == 0) {
                        if (isCleverUser && currentUser.cleverId) {
                            await handleCleverClassesUserSync(currentUser.cleverId, currentClass.id);
                        } else if (isClassLinkuser && currentUser.classlinkid && currentUser.classlinkTenantId) {
                            await handlesynClassUsers(currentUser.classlinkid, currentUser.classlinkTenantId, currentClass.id);
                        }
                    }
                    const classes = await dispatch(handleListLastSemActiveClass(currentClass.id))
                    if (Array.isArray(classes)) {
                        const sortedClasses = classes
                            .sort((a, b) => (b.no_of_student_have_submission || 0) - (a.no_of_student_have_submission || 0))
                            .slice(0, 1)
                            .map(item => {
                                const classInfo = typeof item.classInfo === 'string' ? JSON.parse(item.classInfo) : item.classInfo;
                                return {
                                    id: classInfo?.id,
                                    displayName: classInfo?.displayName || classInfo?.name,
                                    no_of_student_have_submission: item.no_of_student_have_submission
                                };
                            });
                        const choosenClass = sortedClasses[0];
                        if (choosenClass && choosenClass.no_of_student_have_submission > 0) {
                            setBringDataModal(true);
                        }
                    }
                } catch (error) {

                } finally {
                    setSpinLoader(false);
                }
            }
        }
    }, [classUsers, isCleverUser, currentUser, currentClass?.id, isClassLinkuser, dispatch])

    const handleBringDataSuccess = async (success, message) => {
        setOpen(true);
        setPopupMessage(message);
        if (success && currentClass?.id) {
            await Promise.allSettled([
                dispatch(handleListClassActivities(currentClass.id)),
                dispatch(handleListClassQuizzes(currentClass.id)),
                dispatch(handleListClassUsers(currentClass.id)),
                dispatch(handleListClassSubmissions(currentClass.id)),
                fetchClassGameActivity(),
                dispatch(handleListClassUsers(get(currentClass, "id")))
            ]);
        }
    };
    if (itemloading) return <GradebookSkeleton />;
    return (
    <SentryWrap>
        <>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={openPop}
                autoHideDuration={5000}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity="info">
                    <strong>ALERT:</strong> {popupMessage}
                </Alert>
            </Snackbar>
            <SpinLoader dataloader={spinLoader || assignmentReviewLoading} />
            <Modal
                open={LegendsShow}
                onClose={() => setLegendsShow(false)}
            ><ModalContent>
                    <TbgLabels onClose={() => setLegendsShow(false)} />
                </ModalContent>
            </Modal>
            <BringDataFromSectionModal
                open={bringDataModal}
                onClose={() => setBringDataModal(false)}
                currentClass={currentClass}
                currentUser={currentUser}
                currentDisplayedSem={currentDisplayedSem}
                parentOrgId={parentOrgId}
                onSuccess={handleBringDataSuccess}
            />
            <Drawer
                height='100%'
                destroyOnHidden
                onClose={() => {
                    toggleChangePasswordDrawer(false);
                }}
                placement='top'
                open={changePasswordDrawer}
                key='changePassword'
            >
                <CenterContainer>
                    <ChangePasswordForm
                        userData={userData}
                        loading={loading}
                        onClosed={() => {
                            toggleChangePasswordDrawer(false);
                            dispatch(handleListClassUsers(currentClass.id));
                        }}
                    />
                </CenterContainer>
            </Drawer>
            <Drawer
                height='100%'
                destroyOnHidden
                onClose={() => {
                    toggleUserDrawer(false);
                }}
                placement='top'
                open={userDrawer}
                key='quizNew'
            >
                <CenterContainer>
                    {maxExceedError && (
                        <Error>Unable to register student, max number of licenses exceeded.</Error>
                    )}
                    {userDrawer && <StudentForm
                        data={userData}
                        currentClass={currentClass}
                        setFormatPasswordError={setFormatPasswordError}
                        formatPasswordError={formatPasswordError}
                        isReviewAccount={isReviewAccount}
                        editing={editing}
                        loading={loading}
                        handleChange={(id, value, usernameError) => updateUserData(id, value, usernameError)}
                        onClosed={() => {
                            setUserData({});
                            toggleUserDrawer(false);
                        }}
                    />}
                </CenterContainer>
            </Drawer>
            <Drawer
                height='100%'
                destroyOnHidden={false}
                onClose={closeAssignmentDrawer}
                placement='top'
                open={assignmentDrawer}
                key='assignmentNew'
                className='student-review-new'
            >
                <React.Suspense fallback={<AssignmentReviewSkeleton />}>
                    {!isAssignmentReviewReady ? (
                        <AssignmentReviewSkeleton />
                    ) : (
                        <AssignmentReview
                            open={assignmentDrawer}
                            booksAllList={booksAllList}
                            data={assignmentData}
                            usersSubmissionData={selectedAssignmentUserSubmission}
                            currentClass={currentClass}
                            handleClose={handleAssignmentReviewClose}
                            scale_1_5={userPreference?.gradePref == "scale_1_5"}
                            gradebook_a_f={userPreference?.gradePref === "gradebook_a_f"}
                            returnedSubmissionIds={returnedSubmissionIds}
                            onReturnSuccess={onReturnSuccess}
                            showAlert={showAlert}
                        />
                    )}
                </React.Suspense>
            </Drawer>
            <Drawer
                height='100%'
                destroyOnHidden
                onClose={() => {
                    setStudentAssignmentDrawer(false);
                    setAssignmentData({});
                    setSelectedAssignmentSubmissions([])
                }}
                placement='top'
                open={studentAssignmentDrawer}
                key='studentReviewNew'
                className='student-review-new'
            >
                {studentAssignmentDrawer ? <StudentReview
                    open={studentAssignmentDrawer}
                    booksAllList={booksAllList}
                    data={selectedUserData}
                    // usersSubmissionData={selectedUserSubmission}
                    currentClass={currentClass}
                    userReviewAssignment={userReviewAssignment}
                // handleClose={() => {
                //     setLoading(true)
                //     toggleAssignmentDrawer(false)
                //     setLoading(false)
                //     fetchAllData();
                // }}
                scale_1_5={userPreference?.gradePref == "scale_1_5"}
                gradebook_a_f={userPreference?.gradePref === "gradebook_a_f"}
                returnedSubmissionIds={returnedSubmissionIds}
                onReturnSuccess={onReturnSuccess}
                /> : <></>}
            </Drawer>
            <Wrapper>

                <Row gutter={[0, 40]}>
                    <Col span={24}>
                        <GradebookCalendar
                            assignments={getAssignment()}
                            selectedAssignment={selectedAssignment}
                            onSelect={id => setSelectedAssignment(id)}
                            booksAllList={booksAllList}
                            onDateChange={(value) => handleUpdateDatePref(value)}
                            updateDateLoader={updateDateLoader}
                            setDatePrefrences={setDatePrefrences}
                            datePrefrences={datePrefrences}
                            dateRange={gradeTableDateRange}
                            onCalendarDayOrderChange={handlePersistCalendarAssignmentOrder}
                        />
                    </Col>
                </Row>
                {selectedAssignment && (
                    <>
                        <Row gutter={[0, 40]}>
                            <Col span={24}>
                                {selectedAssignment && (
                                    <>
                                        <Header>
                                            Submissions
                                        </Header>
                                        {studentSubmissions&&studentSubmissions[selectedAssignment]?.length > 0 ? (
                                            studentSubmissions[selectedAssignment].map(x => (
                                                <Submission
                                                    key={x.id}
                                                    onClick={() => reviewAssignment(x)}
                                                    data={x}
                                                    classUsers={classUsers}
                                                />
                                            ))
                                        ) : (
                                            <EmptyState message="No submissions for selected assignment" />
                                        )}
                                    </>
                                )}
                            </Col>
                        </Row>
                    </>
                )}
                <ModalMenu type='listRubricModal' open={openListRubricModal} close={()=> setOpenListRubricModal(false)} />
                <Row gutter={[0, 40]}>
                    <Col span={24}>
                    {mainGradeTableActive ? null : (
                        <Header className=''>
                            <div className="gradebookHeaderInner" style={{display:"flex",flexDirection:"row", alignItems:"center"}}>
                                <b style={{textWrap:"nowrap"}}>No. of students - {get(filterGradebookStudentsByActiveStatus(classUsers, activeInactive), "length", 0)} </b>
                                <div className="gradebookDropdownContainer">
                                <Dropdown className="selctChatDrop" menu={classNav()} placement="bottomLeft" trigger={['click']}>
                                    <ClassSelector className="selctChatOptn" onClick={e => e.preventDefault()}>
                                        
                                        <MenuBook className="selctChatMnu" /><div className="breakTheSentence">{get(currentClass, "displayName", "")}  </div> <CaretDownOutlined className="selctChatOut" />
                                      
                                    </ClassSelector>
                                </Dropdown>
                                {/* Add here dropdown for where user can switch between active / inactive students */}
                                <Dropdown menu={activeInactiveNav()} placement="bottomLeft" trigger={['click']} >
                                    <StudentStatusSelector onClick={(e) => {
                                        e.preventDefault()
                                    }}>
                                        <span>{typeof activeInactive === 'string' ? activeInactive.charAt(0).toUpperCase() + activeInactive.slice(1) : 'Active'} students</span>
                                        <CaretDownOutlined className='selctChatOut' />
                                    </StudentStatusSelector>
                                </Dropdown>
                                {hiddenAssignmentsCount > 0 && (
                                    <div style={{ marginLeft: '6px', display: "flex", flexDirection: "row", alignItems: "center" , color: COLOR.red }}
                                        onClick={(e) => {
                                            e.preventDefault()
                                        }} >
                                        Hidden Assignments {`(${hiddenAssignmentsCount})`}
                                    </div>
                                )}
                                {activeDateFilterDisplay && (
                                <div className="view_Gradebook_DateFilter_SmallScreen">
                                    <span style={{ fontSize: '13px', color: COLOR.gray100, whiteSpace: 'nowrap' }}>
                                        By date: {activeDateFilterDisplay.start} – {activeDateFilterDisplay.end}
                                    </span>
                                    <Button
                                        onClick={() => setGradeTableDateRange('')}
                                        style={{ fontSize: '13px', padding: '2px 8px', color: COLOR.green100, flexShrink: 0 }}
                                    >
                                        Reset
                                    </Button>
                                </div>
                            )}
                                </div>
                            </div>
                            <div className="gradebookMenuDropdown">
                            <Menu
                                selectable={true}
                                className="menuListMobile"
                                style={{ backgroundColor: 'transparent', touchAction: 'manipulation' }}
                                onClick={(e)=>onClickMenu(e)}
                                selectedKeys={howGradeScale ? [getCurrentGradePrefKey(), orderBy === 'asc' ? 'Ascending' : 'Descending'] : [orderBy === 'asc' ? 'Ascending' : 'Descending']}
                                mode="vertical"
                                items={items}
                                openKeys={openKeys}
                                onOpenChange={(v)=>setOpenKeys(v)}
                                triggerSubMenuAction="click"
                                getPopupContainer={(node) => node.parentNode}
                            />
                            </div>
                            {/* <Menu selectable={false} className='menuListMobile' style={{backgroundColor:'transparent'}} onClick={onClickMenu} selectedKeys={[current]} mode="horizontal" items={items} /> */}
                            {/* <Wrap className='gradeBokWrp hideMenuSection'> */}
                            <div className="gradeBookViewGradeWrapper">
                                <Wrap className='gradeBokWrp'>
                                <ViewDropdown
                                    config={highlightConfig}
                                    onChange={setHighlightConfig}
                                    dateRange={gradeTableDateRange}
                                    onDateRangeChange={setGradeTableDateRange}
                                    activeSem={currentDisplayedSem}
                                    parentOrgId={parentOrgId}
                                />
                                 <Button className="mr-10px" onClick={() => {
                                        handeListSubmissionAPI();
                                    }}>
                                        <span className='flex items-center'><RefreshOutlined  style={{ fontSize: '16px', marginRight: '4px'}}/> Refresh</span>
                                    </Button>
                               {!isCurrentSem? <Tooltip title={editPrevSemData?"Previous semester data edit enabled":"Previous semester data edit disabled"}>
                                    <Button onClick={() => {
                                        setEditPrevSemData(!editPrevSemData)
                                        localStorage.setItem('editPrevSemData', !editPrevSemData)
                                    }}
                                        style={{ marginRight: '16px', color: !editPrevSemData ? COLOR.green100 : COLOR.red }}
                                    >
                                        <EditOutlined style={{ marginRight: '4px' }} />
                                        {editPrevSemData ? "Disable Edit" : "Enable Edit"}
                                    </Button>
                                </Tooltip>:null}
                               {(loading || rubricLoading) ? <Loading size={15} style={{marginRight:"5px"}} /> : (
                                    <Button className='flex items-center gap-3 mr-16px cursor-pointer' onClick={()=> {
                                        onRubricClick();
                                    }}>
                                    <PlusCircleOutlined className='mr-4px'/> Rubric
                                    </Button>
                               )}
                                <Dropdown menu={orderNav()} placement="bottomLeft" trigger={['click']}>
                                    <Button style={{ marginRight: '16px', display: "flex", flexDirection: "row", alignItems: "center" }}
                                        disabled={updateorderByLoader}
                                        onClick={(e) => {
                                            e.preventDefault()
                                        }} >
                                        <InfoCircleOutlined style={{ marginRight: '4px' }} />
                                        {updateorderByLoader && <Loading size={15} />}
                                        Order By date ({orderBy})
                                    </Button>
                                </Dropdown>
                                {howGradeScale&&
                                    <Dropdown menu={gradeNav()} placement="bottomLeft" trigger={['click']}>
                                        <Button style={{ marginRight: '16px', display: "flex", flexDirection: "row", alignItems: "center" }}
                                            disabled={updatePrefLoader}
                                            onClick={(e) => {
                                                e.preventDefault()
                                            }} >
                                            <InfoCircleOutlined style={{ marginRight: '4px' }} />
                                            {updatePrefLoader && <Loading size={15} />}
                                            {scale_1_5 ? GRADE_PREF[1].value : gradebook_a_f ? GRADE_PREF[2].value : GRADE_PREF[0].value}
                                        </Button>
                                    </Dropdown>

                                }
                                {isSchoologyUser &&
                                    <Button style={{ marginRight: '16px', display: "flex", flexDirection: "row", alignItems: "center" }}
                                        onClick={(e) => {
                                            syncToSchoology()
                                        }} >
                                        <InfoCircleOutlined style={{ marginRight: '4px' }} />
                                        {syncLoader ? <Loading size={20}  /> :null} Sync to Schoology
                                    </Button>
                                }
                                {isCanvasUser &&
                                    <Dropdown menu={canvasSyncNav()} placement="bottomLeft" trigger={['click']}>
                                        <Button
                                            style={{ marginRight: '16px', display: "flex", flexDirection: "row", alignItems: "center" }}
                                            disabled={syncLoader || dedupeLoader}
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <InfoCircleOutlined style={{ marginRight: '4px' }} />
                                            {(syncLoader || dedupeLoader) ? <Loading size={20} /> : null}
                                            Sync canvas
                                            <CaretDownOutlined style={{ marginLeft: 4 }} />
                                        </Button>
                                    </Dropdown>
                                }
                                {isGoogleUser &&
                                    <Button style={{ marginRight: '16px', display: "flex", flexDirection: "row", alignItems: "center" }}
                                        onClick={(e) => {
                                            handleGoogleClassRomm()
                                        }} >
                                        <InfoCircleOutlined style={{ marginRight: '4px' }} />
                                        {syncLoader ? <Loading size={20}  /> :null} Sync google classroom
                                    </Button>
                                }
                                <Button onClick={() => {
                                    handleLegendsShow();
                                }} style={{ marginRight: '16px' }}>
                                    <InfoCircleOutlined style={{ marginRight: '4px' }} />
                                    Legends
                                </Button>
                                {gradeView !== "gradetable"?<Dropdown menu={downloadNav(classActivityData.concat(classQuizzesData), filter(classUsers, x => x.role === 'student'), groupBy(assignment_submission, 'userId'))} placement="bottomLeft" trigger={['click']}>
                                    <Button onClick={e => e.preventDefault()} style={{ marginRight: '16px' }}>
                                        <DownloadOutlined style={{ marginRight: '4px' }} />
                                        Download
                                    </Button>
                                </Dropdown>:
                                 <GradeDownloader
                                    onDownoad={onDownloadFile}
                                    ref={gradeDownloadRef}
                                    scale_1_5={userPreference?.gradePref == "scale_1_5"}
                                    gradebook_a_f={userPreference?.gradePref === "gradebook_a_f"}
                                    schoologyGradeCategory={schoologyGradeCategory}
                                    sortBy={sortBy}
                                    datePrefrences={datePrefrences}
                                    activeSem={currentDisplayedSem}
                                    orderBy={orderBy}
                                    activeInactive={activeInactive}
                                    classUsers={classUsers}
                                    gradeTableDateRange={gradeTableDateRange}
                                />}
                                {!isUserFromOtherPlatform && <Button onClick={() => {
                                    setEditing(false);
                                    setUserData({
                                        username: '',
                                        password: ''
                                    });
                                    toggleUserDrawer(true);
                                }}>
                                    <PlusSquareOutlined style={{ marginRight: '4px' }} />
                                    Add Student
                                </Button>}
                                {isSemester2 && (isCleverUser || isClassLinkuser) && (
                                    <Button onClick={handleBringDataClick} disabled={bringDataLoading} style={{ marginRight: '16px', display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        {bringDataLoading ? <Loading size={15} style={{ marginRight: '4px' }} /> : <InfoCircleOutlined style={{ marginRight: '4px' }} />}
                                        Bring Semester 1 Data
                                    </Button>
                                )}
                            </Wrap>
                            {activeDateFilterDisplay && (
                                <div className="view_Gradebook_DateFilter_LargeScreen">
                                    <span style={{ fontSize: '13px', color: COLOR.gray100, whiteSpace: 'nowrap' }}>
                                        By date: {activeDateFilterDisplay.start} – {activeDateFilterDisplay.end}
                                    </span>
                                    <Button
                                        onClick={() => setGradeTableDateRange('')}
                                        style={{ fontSize: '13px', padding: '2px 8px', color: COLOR.green100, flexShrink: 0 }}
                                    >
                                        Reset
                                    </Button>
                                </div>
                            )}
                        </div>
                        </Header>
                    )}
                        <GradeTable
                            activities={activities}
                            currentClass={currentClass}
                            currentOrg={currentOrg}
                            dataLoading={loading}
                            reviewAssignment={reviewAssignment}
                            userReviewAssignment={userReviewAssignment}
                            setUserData={setUserData}
                            toggleUserDrawer={toggleUserDrawer}
                            toggleChangePasswordDrawer={toggleChangePasswordDrawer}
                            quizzes={quizzes}
                            submissions={assignment_submission}
                            orderBy={orderBy}
                            datePrefrences={datePrefrences}
                            users={classUsers}
                            setEditing={setEditing}
                            booksAllList={booksAllList}
                            isReviewAccount={isReviewAccount}
                            handleEditQuiz={handleEditQuiz}
                            handleEditActivity={handleEditActivity}
                            currentUser={currentUser}
                            userPreference={userPreference}
                            classActivities={classActivityData}
                            getAssignmentCreation={getAssignmentCreation}
                            classQuizzes={classQuizzesData}
                            gradeView={gradeView}
                            setGradeViw={setGradeViw}
                            setExamData={setExamData}
                            gradeData={gradeData}
                            setGradeData={setGradeData}
                            editPrevSemData={editPrevSemData}
                            isCurrentSem={isCurrentSem}
                            setCurrentSem={setCurrentSem}
                            setSortBy={setSortBy}
                            highlightConfig={highlightConfig}
                            activeInactive={activeInactive}
                            onSemesterChange={onSemesterChange}
                            gradeDownloaderRef={gradeDownloadRef}
                            gradeTableDateRange={gradeTableDateRange}
                            onGradeTableDateRangeChange={setGradeTableDateRange}
                        />
                    </Col>
                </Row>
            </Wrapper>
        </>
    </SentryWrap>
    );
};


const mapStateToProps = state => ({
    classActivities: state.classActivities,
    classQuizzes: state.classQuizzes,
    currentUser: state.currentUser,
    classUsers: state.classUsers,
    currentClass: state.currentClass,
    currentOrg: state.currentOrg,
    submissions: state.submissions,
    booksAllList: state.booksAllList,
    userPreference: state.userPreference,
    activities: state.activities,
    quizzes: state.quizzes,
});

export default connect(mapStateToProps, null)(Gradebook);
